import Vacations from "./Vacations";

export default Vacations;